import React, {ReactElement} from "react";
import {Action} from "./types";
import {BaseApp, DIALOG_FLAG_SHOW_CLOSE, DIALOG_FLAG_SHOW_DIALOG_FULLSCREEN} from "./BaseApp";
import {FormGenCamera, FormGenCameraMode} from "./FormGenCamera";
import {StoredDataFileUploadFragment} from "./StoredDateFileUploadFragment";
import {ActionsDialogContent} from "./Dialogs";
import {FormGenContentItem, FormGenLayoutSource} from "./FormGenContainer";

export function FormGenProfilePhotoOptionsDialog({contentItem, source}: {
  contentItem: FormGenContentItem,
  source: FormGenLayoutSource
}): ReactElement {
  const actions: Action[] = [
    new Action("Take Photo", () => {
      const id = BaseApp.CONTEXT.showDialog({flags: DIALOG_FLAG_SHOW_CLOSE | DIALOG_FLAG_SHOW_DIALOG_FULLSCREEN}, () =>
        <FormGenCamera
          contentItem={contentItem}
          source={source}
          onDone={() => BaseApp.CONTEXT.hideDialog(id)}/>);
    }),
    new Action("Upload", () => {
      BaseApp.CONTEXT.showDialog(null, () => <StoredDataFileUploadFragment
        isDialog={true}
        deferUpload={true}
        mimeTypes={["image/*"]}
        storedDataSource={contentItem.metadata.profilePhotoStoredDataSource || "profile-photos"}
        initialUrls={[source.getValue(contentItem)]}
        onSelectionChanged={(urls: string[]) => {
          source.setValue(contentItem, urls[0]);
        }}/>);
    }),
    Boolean(source.getValue(contentItem))
      ? new Action("Edit", () => {
        const id = BaseApp.CONTEXT.showDialog({flags: DIALOG_FLAG_SHOW_CLOSE | DIALOG_FLAG_SHOW_DIALOG_FULLSCREEN}, () =>
          <FormGenCamera
            mode={FormGenCameraMode.PREVIEW}
            contentItem={contentItem}
            source={source}
            onDone={() => BaseApp.CONTEXT.hideDialog(id)}/>);
      })
      : null,
    new Action("Remove", () => {
      source.setValue(contentItem, null);
    }),
  ].filter(Boolean);
  return <ActionsDialogContent actions={actions}/>;
}